import { ComponentProps } from 'react';
import { Animated, Image, ImageURISource, View } from 'react-native';
import { Blurhash } from 'react-blurhash';
import { Required } from 'utility-types';

import { CachedImage } from '@pletly/ui';
import styles from './ImagePlaceholder.styles';
import { useImageWithBlurhash } from './useImageWithBlurhash';

export const ImageWithBlurhash = ({ source, ...imageProps }: Props) => {
	const { fadedIn, opacity, handleOnLoad } = useImageWithBlurhash(imageProps.onLoad);
	const { blurhash, ...sourceWithoutBlurhash } = source;

	return (
		<View style={styles.full}>
			{blurhash && !fadedIn && <Blurhash hash={blurhash} width="100%" height="100%" />}

			<Animated.View style={[styles.imageWrapper, { opacity }]}>
				<CachedImage
					key={source.uri}
					source={sourceWithoutBlurhash}
					{...imageProps}
					style={imageProps.style}
					onLoad={handleOnLoad}
					resizeMode="contain"
				/>
			</Animated.View>
		</View>
	);
};

type Props = Omit<ComponentProps<typeof Image>, 'source'> & {
	source: Required<ImageURISource, 'uri'> & { blurhash?: string | null };
};

export type { Props as ImageWithBlurhashProps };
